import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {McqModel} from '../../models';
import {MultiSelectMcqStore} from '../MultiSelectMcqStore';

interface Props {
  id: number,
  model: McqModel,
  store: X9ContentStateStore,
  lessonType?: string
}

function* renderer(store: MultiSelectMcqStore, lessonType?: string): ReactNodeGenerator {
  const model = store.model;
  if (model.behavior !== 'multi-select')
    return;
  if (store.state === null)
    return;

  const isExam = lessonType === 'Examination';

  for (let index = 0; index < model.choices.length; index++) {
    const choice = model.choices[index];
    const state = store.state.states[index];

    const checked = state.checked;
    const correct = checked && (state.selected === choice.selected);
    const incorrect = checked && (state.selected !== choice.selected);

    const classname = classNames('mcq multi-select', {
      checked: !isExam && state.selected && state.checked,
      correct: !isExam && correct,
      incorrect: !isExam && incorrect
    });
    yield (
      <div className="row" key={index}>
        <div className="col">
          <div className={classname}>
            <div className="form-group">
              <div className="form-check">
                <label className="form-check-label">
                  <input type="checkbox" className="form-check-input"
                         checked={state.selected}
                         onChange={() => store.toggle(index)}
                         disabled={!isExam && correct}/>
                  {choice.label}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isExam) {
    yield (
      <div className="row justify-content-end" key="check">
        <div className="col-auto">
          <button className="btn btn-primary" type="button" onClick={store.check}> Check
          </button>
        </div>
      </div>);
  }
}

@observer
export class StudentMultiSelectMcq extends React.Component<Props> {
  readonly store: MultiSelectMcqStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new MultiSelectMcqStore(props.id, props.model, props.store);
  }

  render() {
    return Array.from(renderer(this.store, this.props.lessonType));
  }
}
